import { t } from 'ember-intl';
import { HttpError } from 'core/components';

<template>
  <HttpError @code="404" as |Error|>
    <Error.LinkStandalone
      @icon="chevron-left"
      @iconPosition="leading"
      @route="cloud"
      @text={{t "helpers.options-for-http-error.go-back"}}
    />
  </HttpError>
</template>
